















import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { MfaStatusEnum } from "../types";
import { RawLocation } from "vue-router";
import Login from "@/shared/components/Login.vue";
import EmployerPortalOktaLogin from "@/shared/components/EmployerPortalOktaLogin.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    GenericLoadingSpinner,
    Login,
    EmployerPortalOktaLogin
  }
})
export default class LoginDecider extends Vue {
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();

  @Prop()
  routeToForgotPassword;

  @Prop()
  routeToUpdatePassword: (user: string, password: string) => Location;

  @Prop()
  MfaRouteFunc: (username: string, password: string, mfaStatus: MfaStatusEnum,
                  SetupBiometricAuth: boolean) => RawLocation;

  @Prop()
  routeToBiometricAuthSetup: (user: string, password: string) => Location;

  get isFeatureFlagReady () {
    return this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.featureFlagsAvailable;
  }

  get showEmployerPortalOktaLogin () {
    return this.userStore.isEmployerPortal && this.featureFlagStore.flags.bend23884EmpPortalOktaLogin;
  }

}
